// extracted by mini-css-extract-plugin
export default {"custominput":"CustomInput_custominput__xO8JS","custominput__title":"CustomInput_custominput__title__06r0b","custominput__input":"CustomInput_custominput__input__eqWti"};